module.exports = __webpack_public_path__ + "img/500.d3b7136.png";